import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'ui/ReactTable';
import { Button } from '@material-ui/core';
import { RedButton } from './Grid.styles';


const Grid = ({ data, onEdit, removeItem }) => (
  <div>
    <ReactTable
      data={data}
      columns={[
        {
          Header: 'ID',
          accessor: 'idModuleSemester',
          maxWidth: 30,
        },
        {
          Header: 'Nombre semestre',
          accessor: 'stage',
        },
        {
          Header: 'Límite horas',
          accessor: 'hoursLimit',
          maxWidth: 120,
        },
        {
          Header: 'Nº Semestre',
          accessor: 'semester',
          maxWidth: 120,
        },
        {
          Header: 'Año curso',
          accessor: 'courseYear',
          maxWidth: 120,
        },
        {
          Header: 'Orden',
          accessor: 'order',
          maxWidth: 120,
        },
        {
          Header: 'Acciones',
          fixed: 'right',
          columns: [
            {
              Cell: row => (
                <Button onClick={() => onEdit(row.original.idModuleSemester)}>Editar</Button>
              ),
              resizable: false,
              sortable: false,
              maxWidth: 70,
            },
            {
              Cell: row => (
                <RedButton onClick={() => removeItem(row.original.idModuleSemester)}>
                    Borrar
                </RedButton>
              ),
              resizable: false,
              sortable: false,
              maxWidth: 100,
            },
          ],
        },
      ]}
    />
  </div>
);

Grid.propTypes = {
  data: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
};

export default Grid;
